export default __webpack_public_path__ + "static/media/suspendedSite.c8223186.svg";